import './style.scss';

export function text_hero_block() {
    const block = document.querySelector('.text_hero_block');
    if (!block) return;

}
